(function () {
	'use strict';

	/**
	 * @ngdoc directive
	 * @name mx.shell:mxRelinkEvent
	 * @module mx.shell
	 * @restrict 'A'
	 * @description
	 * Rerender transluded html content on some event
	 *
	 * @usage <mx-some-component mx-relink-event="NAME_OF_THE_EVENT" ></mx-some-component>
	 */

	angular.module('mx.components').directive('mxRelinkEvent', MxRelinkEvent);

	MxRelinkEvent.$inject = ['mx.shell.EventService'];
	function MxRelinkEvent(eventService) {
		return {
			transclude: 'element',
			restrict: 'A',
			link: function (scope, element, attr, ctrl, transclude) {
				var previousContent = null;

				var triggerRelink = function () {
					if (previousContent) {
						previousContent.remove();
						previousContent = null;
					}

					transclude(function (clone) {
						element.parent().append(clone);
						previousContent = clone;
					});
				};

				triggerRelink();
				eventService.subscribeTo(attr.mxRelinkEvent, triggerRelink, scope);
			},
		};
	}
})();
